import { render } from "./Fifth.vue?vue&type=template&id=682c6a44&scoped=true"
import script from "./Fifth.vue?vue&type=script&lang=js"
export * from "./Fifth.vue?vue&type=script&lang=js"

import "./Fifth.vue?vue&type=style&index=0&id=682c6a44&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682c6a44"]])

export default __exports__